import * as types from '@/store/mutationTypes';
import API from '@/api';

const state = {
  referrer: {},
};

const mutations = {
  [types.SET_REFERRER_INFO](appState, referrer) {
    // eslint-disable-next-line no-param-reassign
    appState.referrer = referrer;
  },
};

const getters = {
  referrer: appState => appState.referrer,
};

const actions = {
  async getReferrerInfo({ commit }, code) {
    const response = await API.referral.getReferrerInfo(code);
    commit(types.SET_REFERRER_INFO, response.data);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/referrals.js